import React from 'react';
import { Template } from '@bynder-studio/render-core';
import { Layers } from 'packages/common/editor/editorComponents/layers/Layers';
import { flattenTree } from 'packages/common/editor/helpers/elementtree';
import { elementHasAnimations } from 'packages/common/editor/timeline/tracks/track-renderer';
import { PresetItemsContainer } from './PresetModal.styled';

const PresetItems = ({ preset }: { preset: Template }) => {
    const elements = Object.values(preset.elements)[0]?.children;

    const layers = Object.values(flattenTree(elements, true)).map((el: any) => ({
        id: el.id,
        type: el.type,
        name: el.name,
        icons: elementHasAnimations(el) ? ['animation'] : [],
    }));

    return (
        <PresetItemsContainer>
            <Layers layers={layers} elements={elements} />
        </PresetItemsContainer>
    );
};

export default PresetItems;
